import React from "react";
import { useMutation } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";
import { postStaf } from "../../../../../services/StafService";
import { useNotification } from "../../../../../context/NotificationProvider";
import { useLocalization } from "../../../../../context/LocalizeContextProvider";
import FormStafClinicComponent from "../../FormStafClinicComponent";
import { retrieveUrlFile } from "../../../../../utils/utils";

export default function AddStafClinic() {
  const notification = useNotification();
  const localize = useLocalization();
  const history = useHistory();

  const { isLoading: isLoadingSubmit, mutate: mutateSubmit } = useMutation(
    postStaf,
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          notification.success(localize.getText("successAddData"));
          history.push("/user-clinic");
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
      },
    }
  );

  const handleSubmitForm = async (value) => {
    let imageUrl = value.imageUrl;

    if (value.imageUrl && value.imageUrl.constructor === File) {
      imageUrl = await retrieveUrlFile(value.imageUrl);
    }

    const data = {
      userPhoneNumber: value.phoneNumber,
      userDob: value.dateOfBirth,
      userGender: value.gender,
      userAddress: value.address,
      name: value.name,
      email: value.email,
      password: value.password,
      role: value.role.value,
      identificationNumber: value.identificationNumber,
      imageUrl: imageUrl,
    };

    mutateSubmit(data);
  };

  return (
    <FormStafClinicComponent
      handleSubmitForm={handleSubmitForm}
      isLoadingSubmit={isLoadingSubmit}
    />
  );
}
